{
	"clientDetailsDialog": {
		"birthDate": "Fecha de nacimiento",
		"editClientData": "Modificar datos de cliente",
		"email": "Email",
		"name": "Nombre",
		"phone": "Teléfono"
	},
	"inputs": {
		"searchPlaceholder": "Buscar"
	},
	"loginForm": {
		"login": "Usuario",
		"org": "Organización",
		"password": "Contraseña",
		"submit": "Enter"
	},
	"multiEntranceInputRelation": {
		"addEntrance": "Agregar entrada",
		"removeEntrance": "Quitar entrada"
	},
	"paymentRequestForm": {
		"account": "Cuenta",
		"accountPlaceholder": "Ex: 44440",
		"agency": "Agency",
		"agencyPlaceholder": "Ex: 5214",
		"alert": "¡Atención! Las solicitudes realizadas después de las 10:30 am (hora de Brasil) solo serán procesadas al día siguiente.",
		"alertAnticipation": "¡Atención! Las solicitudes de anticipación hasta las 18:00h (hora de Brasilia) serán atendidas el siguiente día hábil. Después de este período, las solicitudes se procesarán dentro de dos días hábiles.",
		"bank": "Banco",
		"bankData": "Información del Banco",
		"bankPlaceholder": "Seleccione un banco",
		"buttonSolicitation": "Hacer solicitud",
		"checking": "Cuenta corriente",
		"document": "DNI",
		"documentPlaceholder": "Ex: 123456789",
		"reason": "Motivo",
		"reasonPlaceholder": "Indicar el motivo de la transacción",
		"savings": "Cuenta de ahorros",
		"type": "Tipo",
		"useAnotherBankAccount": "¿Usar una cuenta bancaria estándar?",
		"value": "Valor"
	},
	"placeComboProductInput": {
		"filterProducts": "Filtrar productos"
	},
	"selects": {
		"newFiscalModeOptions": {
			"nfce": "NFC-e",
			"sat": "SAT-e"
		},
		"regimeTributarioOptions": {
			"regimeNormal": "Régimen Normal",
			"simplesNacional": "Simples Nacional",
			"simplesNacionalExcesso": "Simples Nacional Excesso"
		},
		"states": {
			"AC": "Acre",
			"AL": "Alagoas",
			"AM": "Amapá",
			"BA": "Bahia",
			"CE": "Ceará",
			"DF": "Distrito Federal",
			"ES": "Espírito Santo",
			"GO": "Goiânia",
			"MA": "Maranhão",
			"MG": "Minas Gerais",
			"MS": "Mato Grosso do Sul",
			"MT": "Mato Grosso",
			"PA": "Pará",
			"PB": "Paraíba",
			"PE": "Pernambuco",
			"PI": "Piauí",
			"PR": "Paraná",
			"RJ": "Rio de Janeiro",
			"RN": "Rio Grande do Norte",
			"RO": "Rondônia",
			"RR": "Roraima",
			"RS": "Rio Grande do Sul",
			"SC": "Santa Catarina",
			"SE": "Sergipe",
			"SP": "São Paulo",
			"TO": "Tocantins"
		}
	},
	"validations": {
		"invalidEmail": "Dirección de email no válida",
		"requiredField": "Este campo es obligatorio",
		"requiredFieldShort": "Campo obligatorio"
	}
}
